import { SuppliesInventoryConfigStatusSchema } from "@redotech/redo-fulfillment-common/supplies";
import { suppliesInventoryConfigIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

export const updateSuppliesInventoryConfig = {
  name: "updateSuppliesInventoryConfig" as const,
  input: z.object({
    id: suppliesInventoryConfigIdFormat.schema,
    status: SuppliesInventoryConfigStatusSchema.optional(),
    inventoryReorderThreshold: z.number().int().min(0).optional(),
    suppliesReorderQuantity: z.number().int().min(1).optional(),
    // Omitted leaves it alone; null clears the override back to the catalog
    // default; a number overrides it for this product at this location.
    leadTimeDaysOverride: z.number().int().positive().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
